/**
 * de-DE-Formate (UX_KONZEPT.md §4 Punkt 10): Datum TT.MM.JJJJ, Zahlen mit
 * Komma/Tausenderpunkt. Zentral statt an jeder Stelle neu `Intl.*` zu bauen.
 */

const DATE_FMT = new Intl.DateTimeFormat("de-DE")
const NUMBER_FMT = new Intl.NumberFormat("de-DE")

/** Formatiert ein ISO-Datum/Datetime als TT.MM.JJJJ; `null`/ungültig -> "—". */
export function formatDatum(value: string | null | undefined): string {
  if (!value) return "—"
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return "—"
  return DATE_FMT.format(d)
}

/** Formatiert eine Zahl mit Komma/Tausenderpunkt; `null` -> "—". */
export function formatZahl(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—"
  return NUMBER_FMT.format(value)
}

/** Zahl + Einheit mit schmalem Leerzeichen ("12,5 kWh"). */
export function formatEinheit(value: number | null | undefined, einheit: string): string {
  if (value === null || value === undefined) return "—"
  return `${NUMBER_FMT.format(value)} ${einheit}`
}
